module.exports = __webpack_public_path__ + "static/media/space-configuration-icon-selected.ec3bf7e1.svg";